export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxQlgc6SjTjQJElg.4378e75f.woff2";